import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import Helper from "../../../Helper";
import { CommandCenterView } from "../../../models/CommandCenterView";
import { ExecutiveCommandSection } from "../../../models/ExecutiveCommandSection";
import { ExecutiveCommandView } from "../../../models/ExecutiveCommandView";

interface ExecutiveCommandCenterView {
    position: 0 | 1 | 2 | 3;
    jobsite: any;
    commandCenterView: CommandCenterView;
}

interface ExecutiveCommandSelectMenuProps {
    options: any[];
    position: 0 | 1 | 2 | 3;
    onChange: (section: ExecutiveCommandSection | null) => void;
    section: ExecutiveCommandSection | undefined;
    selectedView: ExecutiveCommandView | null;
}

// This component lets the user select which Jobsite Command View to display.
const ExecutiveCommandSelectMenu: React.FC<ExecutiveCommandSelectMenuProps> = ({
    options,
    position,
    onChange,
    section,
}) => {
    if (!options || options.length === 0) {
        return <div>No options available</div>;
    }

    const selectJobsite = (jobsiteId: number) => {
        let tempSection;
        const jobsite = options.find((o) => o.jobsite.id === jobsiteId).jobsite;

        if (!section) {
            tempSection = ExecutiveCommandSection.fromApiObject(
                {
                    position: position,
                    projectId: jobsite.id,
                    executiveCommandViewId: null,
                    executiveCommandView: null,
                },
                jobsite.timezone
            );
        } else {
            tempSection = Object.create(section) as ExecutiveCommandSection;
        }

        tempSection.projectId = jobsite.id;

        if (options.find((o) => o.jobsite.id === jobsiteId).commandCenterViews.length === 1) {
            const commandCenterViewId = options.find((o) => o.jobsite.id === jobsiteId).commandCenterViews[0].id;
            tempSection.commandCenterViewId = commandCenterViewId;
        }
        onChange(tempSection);
    };

    const selectCommandCenterView = (event: SelectChangeEvent) => {
        if (!section) {
            return;
        }
        const tempSection = Object.create(section) as ExecutiveCommandSection;
        const commandCenterView = options
            .find((o) => o.jobsite.id === section?.projectId)
            .commandCenterViews.find((v: CommandCenterView) => v.id === Number(event.target.value));
        if (!commandCenterView) {
            return;
        }
        tempSection.commandCenterViewId = commandCenterView.id;
        onChange(tempSection);
    };
    return (
        <div
            className={Helper.classNames(
                "relative h-full w-full  border-b border-neutral-700 z-5 transition-all duration-700 ease-in-out flex items-center justify-center overflow-hidden"
            )}
        >
            <div style={{ zIndex: -1 }} className="absolute inset-0 flowing-gradient opacity-40" />
            <div className="p-16 white rounded-lg shadow-lg z-10 flex flex-col items-center h-full w-full gap-8">
                <img src="/img/png/logo/PLOT.png" alt="PLOT Logo" className="w-1/4 h-auto" />

                <div className="flex flex-col justify-center items-start p-4 gap-4  rounded-lg shadow w-full h-full min-h-[120px] ">
                    <FormControl fullWidth size="medium" variant="standard" className="p-4!">
                        <InputLabel className="text-3xl! ml-4" id="select-label">
                            Select a Jobsite
                        </InputLabel>
                        <Select
                            size="medium"
                            labelId="select-label"
                            id="select"
                            value={section?.projectId || ""}
                            label="Select a Jobsite"
                            className="text-3xl!"
                            onChange={(e) => {
                                selectJobsite(Number(e.target.value));
                            }}
                        >
                            {options
                                .sort((a, b) => a.jobsite.project_name.localeCompare(b.jobsite.project_name))
                                .map((option) => (
                                    <MenuItem className="text-3xl!" key={option.jobsite.id} value={option.jobsite.id}>
                                        {option.jobsite.project_name}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>

                    <FormControl fullWidth variant="standard" className="p-4!">
                        <InputLabel className="text-3xl! ml-4" id="view-select-label">
                            Select a Jobsite Command View
                        </InputLabel>

                        <Select
                            labelId="view-select-label"
                            id="select"
                            value={section?.commandCenterViewId || ""}
                            disabled={!section?.projectId}
                            className="text-3xl!"
                            label="Select a Command Center View"
                            onChange={selectCommandCenterView}
                        >
                            {section?.projectId &&
                                options
                                    .find((o) => o.jobsite.id === section?.projectId)
                                    ?.commandCenterViews.map((view: CommandCenterView) => (
                                        <MenuItem className="text-3xl!" key={view.id} value={view.id.toString()}>
                                            {view.name}
                                        </MenuItem>
                                    ))}
                        </Select>
                    </FormControl>
                </div>
            </div>
        </div>
    );
};
export default ExecutiveCommandSelectMenu;
